import {Constructor} from "../../../global/constructor";
import {Hash} from "~/interfaces/hashInterfaces";
import {ObjectHelper} from "~/helpers/objectHelper";
import CertificateFoundationLayer from "./certificateFoundationLayer";

export default function CertificateFoundationLayerContainer<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    certificate_foundation_layers: Hash<CertificateFoundationLayer> = {};

    get certificateFoundationLayers(): CertificateFoundationLayer[] {
      return ObjectHelper.toArray(this.certificate_foundation_layers)
        .sort((a, b) => a.sort_order - b.sort_order);
    }

    get nextFoundationLayerSortOrder(): number {
      const inputs = this.certificateFoundationLayers;
      if (inputs.length === 0) return 0;
      else return inputs[inputs.length - 1].sort_order + 1;
    }

    recalculateFoundationLayerPositions() {
      this.certificateFoundationLayers.forEach((it, index) => it.sort_order = index);
    }
  };
}
